import { render, staticRenderFns } from "./fan-point-support-dialog.vue?vue&type=template&id=2505e5ab&scoped=true"
import script from "./fan-point-support-dialog.vue?vue&type=script&lang=js"
export * from "./fan-point-support-dialog.vue?vue&type=script&lang=js"
import style0 from "./fan-point-support-dialog.vue?vue&type=style&index=0&id=2505e5ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2505e5ab",
  null
  
)

export default component.exports